import { Flex, SvgIcon } from '@npco/zeller-design-system'

import { ReactComponent as PaymentTerminalIcon } from 'assets/svg/payment-terminal.svg'
import { EXTERNAL_SHOP_URL } from 'const/externalLinks'
import {
  StyledButtonPlaceholder,
  StyledButtonWrapper,
  StyledOrderTerminalLink,
} from 'components/Placeholders/NoInitialResults/NoInitialResults.styled'
import { component } from 'translations'

export const OrderTerminalButton = () => (
  <>
    <StyledButtonWrapper>
      <StyledOrderTerminalLink
        href={EXTERNAL_SHOP_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Flex justifyContent="center">
          <SvgIcon width="16" height="16" withMarginRight>
            <PaymentTerminalIcon />
          </SvgIcon>
          {component.noInitialResults.buttonLabel}
        </Flex>
      </StyledOrderTerminalLink>
    </StyledButtonWrapper>
    <StyledButtonPlaceholder />
  </>
)
